import React from 'react';
import {useIntl} from 'react-intl';

import {withAuthorizationV2} from '../../services/Authorization';

import Tasks from './Tasks';
import './TasksOverview.css';

const TasksOverview = () => {
  const intl = useIntl();

  return (
    <div>
      <header className="main-header">
        <div className="main-header__left">
          <h1 className="main__title">
            {intl.formatMessage({id: 'page.task-overview'})}
          </h1>
        </div>
      </header>

      <div className="main__content">
        <div className="box">
          <Tasks/>
        </div>
      </div>
    </div>
  )
}

export default withAuthorizationV2(TasksOverview, ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']);
